import React, { Component } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route, Routes,
} from 'react-router-dom';
import routePaths from './shared/constants/routePaths';
import { ApplicationState } from './store';
import { connect } from 'react-redux';
import PrivateRoute from './components/login/useTokenExpiration';
import { AuthActions } from './store/auth';
import { UserHelper } from './helpers';
import UnAuthorized from './components/UnAuthorized/UnAuthorized';
import Header from './components/header/Header';
import SignIn from './components/layout/SignIn';
import HomeDashboard from './components/MainLanding/HomeDashboard/HomeDashboard';


interface ComponentProps {
  idToken?: any;
  applicationState?: ApplicationState;
}

type LayoutProps =
  ComponentProps
  & typeof mapDispatchToProps;

class AppRoutes extends Component<React.PropsWithChildren<LayoutProps>> {

  public renderLayout(element: JSX.Element) {
    const { applicationState } = this.props;
    return (
      <React.Fragment>
        <PrivateRoute>
          <Header username={applicationState?.internalUser?.userName} name={applicationState?.internalUser?.idToken?.name} />
          {element}
        </PrivateRoute>
      </React.Fragment>
    );
  }

  renderSign(): JSX.Element {
    return (
      <React.Fragment>
        <Header />
        <SignIn />
      </React.Fragment>
    );
  }

  redirectInternalUserPageBasedAuth(element: JSX.Element, pageName: string): JSX.Element {
    const { applicationState } = this.props;
    if (applicationState && UserHelper.isInternalUserValid(applicationState)
      && UserHelper.isUserAuthorized(applicationState, pageName)) {
      return this.renderLayout(element);
    } else {
      return <Navigate to={routePaths.root} />;
    }
  }

  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path={routePaths.root} element={this.renderSign()} />
          <Route path={routePaths.signIn} element={this.renderSign()} />
          <Route path={routePaths.signInCallback} element={this.renderSign()} />
          <Route path={routePaths.landingPage} element={this.redirectInternalUserPageBasedAuth(<HomeDashboard />, routePaths.landingPage)} />
          <Route path={routePaths.Unauthorized} element={this.renderLayout(<UnAuthorized />)} />
        </Routes>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state: ApplicationState, ownProps: ComponentProps) => {
  const { idToken } = state.internalUser;

  return {
    ...ownProps,
    idToken,
    applicationState: state,

  };
};

const mapDispatchToProps = {
  internalSignOut: AuthActions.signOut
};

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes as any);